import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarIcon, F0Icon } from '@factorialco/f0-react'
import { Comment, Quote } from '@factorialco/f0-react/icons/app'

import { ClientReviewItemProps } from 'modules/marketplace_modules/components/Revamp/types'

export const ReviewItem: React.FC<ClientReviewItemProps> = ({ review }) => {
  return (
    <Box background="white" flexDirection="row" gap="s16">
      <F0AvatarIcon icon={Quote} size="lg" />

      <Box gap="s8">
        <Text size="200" weight="semibold" color="black">
          {review.title}
        </Text>
        <Text size="200">
          <span className="text-f1-foreground-secondary">&ldquo;{review.description}&rdquo;</span>
        </Text>
        <Box gap="s4" flexDirection="row" paddingTop="s4" alignItems="flexStart">
          <F0Icon icon={Comment} color="default" size="md" />
          <Text size="200" color="black">
            {review.author}
          </Text>
          <Text size="200" color="black">
            ·
          </Text>
          <Text size="200" color="black">
            {review.jobPosition}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
